import React, { Component } from 'react';
import {
    Container, Box, Typography, IconButton, List, Paper, Button,
    Menu, MenuItem, ListItemIcon
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import WorkIcon from '@mui/icons-material/Work';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { WithRouter } from '../../../comp/WithRouter';

class AddressSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedId: null,
            anchorEl: null,
            currentMenuId: null
        };
    }

    handleSelect = (id) => this.setState({ selectedId: id });

    handleMenuOpen = (event, id) => {
        this.setState({ anchorEl: event.currentTarget, currentMenuId: id });
    };

    handleMenuClose = () => {
        this.setState({ anchorEl: null, currentMenuId: null });
    };

    render() {
        const { addresses } = this.props;
        const { selectedId, anchorEl, currentMenuId } = this.state;

        return (
            <Container maxWidth="sm" sx={{ p: 0, height: "100vh", display: "flex", flexDirection: "column", bgcolor: "#fff" }}>
                {/* HEADER */}

                <Box
                    sx={{
                        top: 0,
                        bgcolor: "#fff",
                        zIndex: 10,
                        p: 1,
                        display: "flex",
                        alignItems: "center", // Centraliza verticalmente
                        justifyContent: "space-between",
                        borderBottom: "1px solid #ddd",
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: "1.1rem",
                            color: "#263238",
                            lineHeight: 1, // Adicione isso para alinhar com o ícone
                        }}
                    >
                        Endereços
                    </Typography>

                    <IconButton onClick={() => window.history.back()} sx={{ p: 0.5 }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* LISTA */}
                <List sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
                    {addresses.map((addr) => (
                        <Paper
                            key={addr.id}
                            variant="outlined"
                            onClick={() => this.handleSelect(addr.id)}
                            sx={{
                                mb: 2, p: 2, borderRadius: 2, cursor: 'pointer',
                                borderColor: selectedId === addr.id ? 'primary.main' : 'divider',
                                borderWidth: selectedId === addr.id ? 2 : 1
                            }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    {addr.type === 'work' ? <WorkIcon color="action" /> : <HomeIcon color="action" />}
                                    <Box>
                                        <Typography variant="subtitle1" fontWeight={600}>{addr.street}, {addr.house_number}</Typography>
                                        <Typography variant="body2" color="text.secondary">{addr.district} - {addr.city}/{addr.state}</Typography>
                                    </Box>
                                </Box>
                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.handleMenuOpen(e, addr.id); }}>
                                    <MoreVertIcon />
                                </IconButton>
                            </Box>
                        </Paper>
                    ))}
                </List>

                <Button
                    fullWidth
                    sx={{ color: "#1976d2", fontWeight: "bold", mt: 1 }}
                    onClick={() => {
                        this.props.navigate("new");
                    }}
                >
                    ADICIONAR NOVO ENDEREÇO
                </Button>

                {/* MENU DE OPÇÕES */}
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.handleMenuClose}>
                    <MenuItem onClick={() => { console.log('Editar', currentMenuId); this.handleMenuClose(); }}>
                        <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon> Editar
                    </MenuItem>
                    <MenuItem onClick={() => { console.log('Excluir', currentMenuId); this.handleMenuClose(); }} sx={{ color: 'error.main' }}>
                        <ListItemIcon><DeleteIcon fontSize="small" color="error" /></ListItemIcon> Excluir
                    </MenuItem>
                </Menu>

                {/* BOTÃO FIXO */}
                <Box sx={{ p: 2, borderBottom: "1px solid #eee", bgcolor: "#fff" }}>
                    <Button
                        fullWidth variant="contained" size="large"
                        disabled={!selectedId}
                        onClick={() => {
                            fetch("/api/store/address/default", {
                                method: "POST",
                                credentials: "include",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({ address_id: selectedId }),
                            }).then((response) => {
                                if (response.status == 200) {
                                    window.history.back();
                                }
                            })
                        }}
                        sx={{ py: 1.5, borderRadius: 2, textTransform: 'none', fontSize: '1rem' }}
                    >
                        Confirmar
                    </Button>
                </Box>
            </Container>
        );
    }
}

export default WithRouter(AddressSelector);